import { formatPercentage } from './numbers'

export const parseServiceRate = (rate: string) => {
  try {
    const decimal = parseFloat(rate)

    if (Number.isNaN(decimal)) {
      return undefined
    }

    return decimal
  } catch (error) {
    return undefined
  }
}

const serviceRateToPercentage = (rate: string) => {
  if (!rate) {
    return undefined
  }

  const decimal = parseServiceRate(rate)

  if (!decimal) {
    return undefined
  }

  return formatPercentage(decimal)
}

export default serviceRateToPercentage
